/**
 * Cart Page Fix
 * 
 * This script prevents infinite reload loops on the cart page
 * by overriding problematic behaviors from various scripts.
 */

(function() {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on cart page
    if (window.location.pathname === '/cart') {
      console.log('Cart fix script loaded');
      
      // Override window.location.reload to prevent infinite loops
      const originalReload = window.location.reload;
      let reloadCount = 0;
      const maxReloads = 1;
      
      // Create a timestamp to track reload frequency
      window.lastReloadTime = window.lastReloadTime || Date.now();
      
      window.location.reload = function() {
        const now = Date.now();
        const timeSinceLastReload = now - window.lastReloadTime;
        
        console.log(`Reload requested. Time since last reload: ${timeSinceLastReload}ms`);
        
        // If reload is requested too soon after previous reload, block it
        if (timeSinceLastReload < 2000) { // 2 seconds minimum between reloads
          console.log('Prevented reload: too soon after previous reload');
          return false;
        }
        
        if (reloadCount < maxReloads) {
          console.log('Allowing reload: ' + reloadCount);
          reloadCount++;
          window.lastReloadTime = now;
          originalReload.apply(window.location, arguments);
        } else {
          console.log('Prevented reload to avoid infinite loop');
        }
      };
      
      // Try to intercept Appikon AJAX success handler
      if (typeof jQuery !== 'undefined') {
        jQuery(document).off('ajaxSuccess').on('ajaxSuccess', function(event, xhr, settings) {
          if (settings && (settings.url === '/cart/change.js' || settings.url === '/cart/update.js' || settings.url === '/cart/add.js')) {
            console.log('Intercepted cart AJAX success: ' + settings.url);
            event.stopImmediatePropagation();
            return false;
          }
        });
      }
      
      // Also try to intercept the free sample refreshing flag
      window.freeSampleRefreshing = true; // Set to true to prevent initial reload
      console.log('Blocked initial free sample refresh');
    }
  });
})();